/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';

/* istanbul ignore next */
const SpinnerIcon = ({size = 120}) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <rect x="0" y="0" width="100" height="100" fill="none" />
    <circle
      cx="50"
      cy="50"
      r="40"
      stroke="#f5f5f5"
      fill="none"
      strokeWidth="10"
      strokeLinecap="round"
    />
    <circle
      cx="50"
      cy="50"
      r="40"
      stroke="#0099cc"
      fill="none"
      strokeWidth="6"
      strokeLinecap="round"
    >
      <animate
        attributeName="stroke-dashoffset"
        dur="3s"
        repeatCount="indefinite"
        from="0"
        to="502"
      />
      <animate
        attributeName="stroke-dasharray"
        dur="3s"
        repeatCount="indefinite"
        values="225.9 25.099999999999994;1 250;225.9 25.099999999999994"
      />
    </circle>
  </svg>
);

SpinnerIcon.propTypes = {
  size: PropTypes.number,
};

export default SpinnerIcon;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Spinner/SpinnerIcon.js